import { Component, OnInit } from '@angular/core';
import {DropdownComponent} from '../../../../dropdown/dropdown/dropdown.component';
import {DropdownMenu} from '../dropdown-menu';
import {IDropdownMenu} from '../../../idropdown-menu';

@Component({
  selector: 'bs-dropdown-menu-content',
  templateUrl: './dropdown-menu-content.component.html',
  styleUrls: ['./dropdown-menu-content.component.css']
})
export class DropdownMenuContentComponent<T> implements OnInit, IDropdownMenu<T> {

  constructor() { }

  ngOnInit(): void {
  }

  data: T;
  dropdownContainerComponent: DropdownComponent<T>;
  menu: DropdownMenu<T>
}
